export const formatTicketGlobalId = (globalId: number) => {
  return globalId.toString().padStart(10, "0");
};
